import React from 'react';
import Print from "../svgs/Print";
import ReactToPrint from 'react-to-print';
import { StyledPrintButton, StyledPrintLabel } from "./styles";
import PropTypes from "prop-types";

// If using this inside functional component please pass function returning ref.current as contentRef
// If using this inside class component please pass function returning ref as contentRef
export default function PagePrintButton({
  className,
  buttonLabel = "PRINT",
  contentRef,
  printClick,
  id
}) {
  return (
    <div className={`${className} hide-for-print`} onClick={printClick}>
      <ReactToPrint className="i_print"
        trigger={() =>
          <StyledPrintButton>
            <Print />
            {id ? 
              <StyledPrintLabel id={id}>{buttonLabel}</StyledPrintLabel> :
              <StyledPrintLabel>{buttonLabel}</StyledPrintLabel>
            }
          </StyledPrintButton>
        }
        content={contentRef}
        bodyClass="pl2"
      />
    </div>
  )
}

PagePrintButton.propTypes = {
  buttonLabel: PropTypes.string,
  printClick: PropTypes.func
}
